module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/funabashi_ekimae_point3_5-503e2ec13d0ec7d74318384a6e6c9481.jpg";